import { Html } from "@react-three/drei";

/**
 * Live $CROWN price chart on a floating sign beside the pot. Renders an
 * embedded GeckoTerminal chart for the pump.fun pool via drei `<Html transform>`
 * (the same in-3D HTML technique ChartScreen uses), so it tracks its world
 * position as the camera moves rather than being a flat HUD overlay.
 *
 * The pool/embed URL is launch-specific; override with VITE_TOKEN_CHART_URL to
 * point a different launch's sign at its own pool without a code change.
 */

const CROWN_POOL = "HxCT1jxG8TDrnMPJnxWnmi8wMFR2ZVQvfZDC9Tw7LF5x";
const CHART_URL =
  (import.meta.env.VITE_TOKEN_CHART_URL as string | undefined) ??
  `https://www.geckoterminal.com/solana/pools/${CROWN_POOL}?embed=1&info=0&swaps=0&grayscale=0&light_chart=0`;
const TOKEN_LABEL =
  (import.meta.env.VITE_TOKEN_LABEL as string | undefined) ?? "$CROWN / SOL";

interface TokenChartSignProps {
  position: [number, number, number];
  rotation?: [number, number, number];
  /** drei Html scale factor — HIGHER = larger in world (scale ∝ distanceFactor).
   *  Tune for the hall. */
  distanceFactor?: number;
}

export function TokenChartSign({
  position,
  rotation = [0, 0, 0],
  distanceFactor = 8,
}: TokenChartSignProps): JSX.Element {
  return (
    <group position={position} rotation={rotation}>
      <Html
        transform
        distanceFactor={distanceFactor}
        // Render the panel as a display; pointer-lock hides the cursor anyway,
        // so a player must Esc to actually interact with the chart.
        style={{ pointerEvents: "auto", userSelect: "none" }}
      >
        <div style={panelStyle}>
          <div style={headerStyle}>
            <span style={{ fontSize: 15, fontWeight: 800, color: "#f4d36a", letterSpacing: 0.4 }}>
              📈 {TOKEN_LABEL}
            </span>
            <span style={{ fontSize: 11, color: "#7fe19a" }}>● live</span>
          </div>
          <iframe
            title="CROWN live chart"
            src={CHART_URL}
            style={{ width: 420, height: 300, border: 0, display: "block", background: "#0a0a10" }}
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        </div>
      </Html>
    </group>
  );
}

const panelStyle: React.CSSProperties = {
  width: 420,
  background: "#0a0a10",
  border: "2px solid #8a6a28",
  borderRadius: 10,
  overflow: "hidden",
  boxShadow: "0 0 0 1px rgba(244,211,106,0.15), 0 12px 40px rgba(0,0,0,0.6)",
  fontFamily: "ui-sans-serif, system-ui, sans-serif",
};

const headerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 12px",
  background: "linear-gradient(180deg, #1a1208, #0a0a10)",
  borderBottom: "1px solid #5a4a18",
};
